import {Component, OnDestroy, OnInit} from '@angular/core';
import {MapService} from '../../../commons/map.service';
import { PluginManagerService } from '../../../service/plugin-manager.service';

const Cesium = (<any>window).Cesium

@Component({
  selector: 'app-keyboard-navigator',
  template: '' // "<div style='position:fixed;top:100px;left:400px;height:30px;width:130px;background-color:#fff;color:green;'> keys [{{ latestKey }}]</div>"
})
export class KeyboardNavigatorComponent implements OnInit, OnDestroy {

  latestKey:any = null;

  private startMousePosition;
  private mousePosition;
  private flags = {
    looking: false,
    moveForward: false,
    moveBackward: false,
    moveUp: false,
    moveDown: false,
    moveLeft: false,
    moveRight: false,
  };

  countTicks:number = 0;

  private moveRate = 0.04;
  private rotateRate = 0.004;

  private onTickListener: any;
  private onKeyUpListener: any;
  private onKeyDownListener: any;
  private onLeftUpListener: any;
  private onMouseMoveListener: any;
  private onLeftDownListener: any;
  private onLeftDoubleListener: any;
  private handler: any;

  constructor(public mapService: MapService, public pluginManager:PluginManagerService ) {
  }

  ngOnInit() {

      setTimeout ( () => {

        if (this.mapService.viewer) {
          this.mapService.viewer.canvas.setAttribute('tabindex', '0'); // needed to put focus on the canvas
          this.mapService.viewer.canvas.onclick = () => {
            this.mapService.viewer.canvas.focus();
          };
          /*
          this.handler = new Cesium.ScreenSpaceEventHandler(this.mapService.viewer.canvas);
          this.onLeftDownListener = this.onLeftDown.bind(this);
          this.handler.setInputAction(this.onLeftDownListener, Cesium.ScreenSpaceEventType.LEFT_DOWN);
          this.onLeftDoubleListener = this.onLeftDouble.bind(this);
          this.handler.setInputAction(this.onLeftDoubleListener, Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
          this.onMouseMoveListener = this.onMouseMove.bind(this);
          this.handler.setInputAction(this.onMouseMoveListener, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
          this.onLeftUpListener = this.onLeftUp.bind(this);
          this.handler.setInputAction(this.onLeftUpListener, Cesium.ScreenSpaceEventType.LEFT_UP);
          */
          // if ( this.mapService && this.mapService.viewer && this.mapService.viewer.clock ) {
          //   this.onTickListener = this.onTick.bind(this);
          //   this.mapService.viewer.clock.onTick.addEventListener(this.onTickListener);
          // }
          
        } else {
          this.latestKey = 'no viewer';
        }
    
        this.onKeyDownListener = this.onKeyDown.bind(this);
        document.addEventListener('keydown', this.onKeyDownListener, false);
        this.onKeyUpListener = this.onKeyUp.bind(this);
        document.addEventListener('keyup', this.onKeyUpListener, false);

      }, 3000 );

  }
/*
  onLeftDouble(movement: any) {
    var foundPosition = false;
    var pickedObject = this.mapService.viewer.scene.pick(movement.position);
    if (this.mapService.viewer.scene.pickPositionSupported) {
      if (this.mapService.viewer.scene.mode === Cesium.SceneMode.SCENE3D) {
        var cartesian = this.mapService.viewer.scene.pickPosition(movement.position);
        if (Cesium.defined(cartesian)) {
          console.log(cartesian);
          this.mapService.viewer.camera.lookAt(cartesian, new Cesium.Cartesian3(0,0, Math.abs(this.mapService.viewer.camera.position.z)+5));


        }
      }
    }
  }

  onLeftDown(movement: any) {
    this.flags.looking = true;
    this.mousePosition = this.startMousePosition = Cesium.Cartesian3.clone(movement.position);
  }

  onMouseMove(movement: any) {
    this.mousePosition = movement.endPosition;
  }

  onLeftUp(position: any) {
    this.flags.looking = false;
  }
*/
  onKeyDown(e: any) {
    if (e.shiftKey) {
      this.moveRate = 0.05;

    } else {
      this.moveRate = 0.01;

    }
    var flagName = this.getFlagForKeyCode(e.keyCode);
    if (typeof flagName !== 'undefined') {
      this.flags[flagName] = true;
    }

    this.onTick();

  }

  onKeyUp(e: any) {
    var shift = false;
    if (e.shiftKey) {
      shift = true;
    } else {
      shift = false;
    }
    var flagName = this.getFlagForKeyCode(e.keyCode, shift);
    if (typeof flagName !== 'undefined') {
      this.flags[flagName] = false;
    }

    if ( flagName == 'taskbar' ) {
      this.pluginManager.appController.show = ! this.pluginManager.appController.show;
    } else if ( flagName == 'taskbarDebug' ) {
      this.pluginManager.appController.showDebug = ! this.pluginManager.appController.showDebug;
    }

  }

  onTick() {

    this.countTicks++;
    // console.log('#',this.countTicks, this.moveRate, this.flags );

    // let camera = this.mapService.viewer.camera;
    if (this.flags.moveForward) {
      this.mapService.viewer.camera.moveForward(this.moveRate);
    }
    if (this.flags.moveBackward) {
      this.mapService.viewer.camera.moveBackward(this.moveRate);
    }
    if (this.flags.moveUp) {
      this.mapService.viewer.camera.moveUp(this.moveRate);
    }
    if (this.flags.moveDown) {
      this.mapService.viewer.camera.moveDown(this.moveRate);
    }
    if (this.flags.moveLeft) {
      this.mapService.viewer.camera.moveLeft(this.moveRate);
    }
    if (this.flags.moveRight) {
      this.mapService.viewer.camera.moveRight(this.moveRate);
    }
  }

  getFlagForKeyCode(keyCode, shift?: any) {

    this.latestKey = keyCode;

    // console.log('*',keyCode, shift );

    switch (keyCode) {


      case 37:

        return 'moveLeft';
      case 38:

        return 'moveUp';
      case 39:

        return 'moveRight';
      case 40:

        return 'moveDown';


      case 'W'.charCodeAt(0):
        return 'moveForward';
      case 'S'.charCodeAt(0):
        return 'moveBackward';
      case 'Q'.charCodeAt(0):
        return 'moveUp';
      case 'E'.charCodeAt(0):
        return 'moveDown';


      case 'D'.charCodeAt(0):
        return 'moveRight';

      case 'A'.charCodeAt(0):
        return 'moveLeft';

        case 219: return 'taskbar';
        case 221: return 'taskbarDebug';

      //

      case shift:
        return undefined;
      default:
        return undefined;
    }
    
  }

  ngOnDestroy(): void {
    this.removeListeners();
  }

  removeListeners() {
    /*
    try{
      if ( this.mapService.viewer && this.mapService.viewer.clock ) {
        this.mapService.viewer.clock.onTick.removeEventListener(this.onTickListener);
      }
    } catch (e) {
      // this one is safe to go silent
      // console.log(e);
    
    }
    */
    // this.handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOWN);
    // this.handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
    // this.handler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
    // this.handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_UP);
    document.removeEventListener('keydown', this.onKeyDownListener);
    document.removeEventListener('keyup', this.onKeyUpListener);

  }

}
